import { render, staticRenderFns } from "./pageElementUrl.vue?vue&type=template&id=4f450315&scoped=true&"
import script from "./pageElementUrl.vue?vue&type=script&lang=js&"
export * from "./pageElementUrl.vue?vue&type=script&lang=js&"
import style0 from "./pageElementUrl.vue?vue&type=style&index=0&id=4f450315&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f450315",
  null
  
)

export default component.exports